var map = {
	"./AW1.svg": 8670,
	"./AW2.svg": 2040,
	"./AW3.svg": 7354,
	"./AW4.svg": 5660,
	"./Arrow1.svg": 2274,
	"./Arrow2.svg": 1531,
	"./Aw5.svg": 6203,
	"./Eis2_hb_w.jpg": 8019,
	"./f_logo_RGB-Blue_58.png": 8017,
	"./fonts/Rajdhani-Light.ttf": 3676,
	"./fonts/Rajdhani-Regular.ttf": 8567,
	"./fonts/Yantramanav-Bold.ttf": 3027,
	"./fonts/Yantramanav-Light.ttf": 754,
	"./fonts/Yantramanav-Medium.ttf": 2480,
	"./fonts/Yantramanav-Regular.ttf": 4801,
	"./fonts/Yantramanav-Thin.ttf": 8494,
	"./galleryPictures/0_Offen_w_kl.jpg": 7445,
	"./galleryPictures/BrokenWall_w.jpg": 4125,
	"./galleryPictures/Buntkiemer1_w.jpg": 6414,
	"./galleryPictures/Buntkiemer2_w.jpg": 8265,
	"./galleryPictures/Colomaläon_w.jpg": 9150,
	"./galleryPictures/Delfin_gif_reduced.gif": 4800,
	"./galleryPictures/EineVonMillionen_w.jpg": 1622,
	"./galleryPictures/Eis2_hb_w.jpg": 6356,
	"./galleryPictures/Eisbaer_Detail_2_b_w.jpg": 7271,
	"./galleryPictures/Eisbaer_Detail_b_w.jpg": 9651,
	"./galleryPictures/Eisbaer_Frontal_2_b_w.png": 7550,
	"./galleryPictures/Eisbaer_Frontal_w.jpg": 5289,
	"./galleryPictures/Eisbaer_Oben_w.jpg": 8255,
	"./galleryPictures/Eisbaer_Quer_w.jpg": 5383,
	"./galleryPictures/ErstarrtHinterGittern1_w.jpg": 4716,
	"./galleryPictures/ErstarrtHinterGittern_gorilla_w.jpg": 3311,
	"./galleryPictures/ErstarrtHinterGittern_schimpanse_w.jpg": 3813,
	"./galleryPictures/Farbenfisch_w.jpg": 752,
	"./galleryPictures/Gejagt_w.jpg": 6457,
	"./galleryPictures/Giraffenpuppe_kl_w.jpg": 8643,
	"./galleryPictures/Gurr_w.jpg": 6548,
	"./galleryPictures/Jellish_kl_w.jpg": 415,
	"./galleryPictures/Kaninchen_gif_reduced.gif": 7982,
	"./galleryPictures/Laubtraumfänger_w.jpg": 8319,
	"./galleryPictures/Meise_nv_w.jpg": 3017,
	"./galleryPictures/Moritzburg_w.jpg": 5370,
	"./galleryPictures/Muuh3_Wiese_nv_w.jpg": 8600,
	"./galleryPictures/Muuh3_w.jpg": 9436,
	"./galleryPictures/Okdelisch_w.jpg": 629,
	"./galleryPictures/P1060322.jpg": 8221,
	"./galleryPictures/P1060328.jpg": 6963,
	"./galleryPictures/P1060333.jpg": 6541,
	"./galleryPictures/P1060339.jpg": 2766,
	"./galleryPictures/P1060343.jpg": 5557,
	"./galleryPictures/P1060346.jpg": 8815,
	"./galleryPictures/P1060349.jpg": 8829,
	"./galleryPictures/P1060350.jpg": 3933,
	"./galleryPictures/P1060352.jpg": 9281,
	"./galleryPictures/P1060354.jpg": 5107,
	"./galleryPictures/P1060355.jpg": 7526,
	"./galleryPictures/P1060356.jpg": 4805,
	"./galleryPictures/P1060359.jpg": 9332,
	"./galleryPictures/P1060368.jpg": 8780,
	"./galleryPictures/P1060371.jpg": 6803,
	"./galleryPictures/P1060373.jpg": 2137,
	"./galleryPictures/P1060375.jpg": 4724,
	"./galleryPictures/P1060376.jpg": 1871,
	"./galleryPictures/P1060377.jpg": 2644,
	"./galleryPictures/P1060378.jpg": 5531,
	"./galleryPictures/P1060380.jpg": 4542,
	"./galleryPictures/P1060382.jpg": 8628,
	"./galleryPictures/P1060386.jpg": 3890,
	"./galleryPictures/P1060388.jpg": 3705,
	"./galleryPictures/P1060392.jpg": 5678,
	"./galleryPictures/P1060393.jpg": 8699,
	"./galleryPictures/P1060394.jpg": 6323,
	"./galleryPictures/P1060395.jpg": 7775,
	"./galleryPictures/P1060396.jpg": 2081,
	"./galleryPictures/P1060398.jpg": 2730,
	"./galleryPictures/P1060400.jpg": 4979,
	"./galleryPictures/Piep2_w.jpg": 2063,
	"./galleryPictures/Rückkehr_w.jpg": 6453,
	"./galleryPictures/Schildkröte_w.jpg": 4785,
	"./galleryPictures/Schildkrötenhölle_w.jpg": 850,
	"./galleryPictures/Staring1_gif_reduced.gif": 9776,
	"./galleryPictures/Staring2_gif_reduced.gif": 8883,
	"./galleryPictures/Tintenfisch_kl_w.jpg": 4593,
	"./galleryPictures/WaldleuchtenCollage_w.jpg": 5594,
	"./galleryPictures/Wellensittich-Befreiung_w.mp4": 2518,
	"./galleryPictures/Wellensittich_gif_reduced.gif": 8223,
	"./galleryPictures/Welli_hinter_Gittern_1_w.jpg": 6085,
	"./galleryPictures/WhatRemains_w.jpg": 2113,
	"./galleryPictures/WhiteWall.jpg": 12,
	"./galleryPictures/Wolkenmaus_final2_w_s.jpg": 9176,
	"./galleryPictures/Wolkennashorn_w.jpg": 7052,
	"./galleryPictures/Wolkenvogel_final_w_s.jpg": 36,
	"./galleryPictures/Wüstenwürfel_w.jpg": 1013,
	"./galleryPictures/Zerrissen_w.jpg": 5799,
	"./galleryPictures/abyss_w.jpg": 2039,
	"./logo.png": 6949
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;